import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import _ from 'lodash';

import { useFetchLines } from './use-fetch-lines';
import { useFetchCompanies } from './use-fetch-companies';

export const useFetchFilteredCompaniesByLine = (
  config = { lineRequest: {}, boStrip: false, boWithUsers: false }
) => {
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const { values, setFieldValue } = useFormikContext();

  const { loading: LoadingLines, lines } = useFetchLines(config.lineRequest);
  const { loading: loadingCompanies, companies } = useFetchCompanies(config);

  const loading = LoadingLines || loadingCompanies;

  useEffect(() => {
    if (!values.linhas) return;
    if (values.linhas.length === 0) {
      setFilteredCompanies(companies);
    } else {
      const lineObjList = getLineObjectsFromIds(values.linhas, lines);
      setFilteredCompanies(filterCompaniesByLines(lineObjList, companies));
    }
    // eslint-disable-next-line
  }, [values.linhas, companies]);

  useEffect(() => {
    if (!values.empresas) return;
    if (!values.linhas) return;
    const lineObjList = getLineObjectsFromIds(values.linhas, lines);
    const companyList = getCompanyObjectsFromIds(values.empresas, companies);
    const filtered = filterCompaniesByLines(lineObjList, companyList);
    const onlyCdEmpresa = filtered.map(line => line.cdEmpresa);

    setFieldValue('empresas', onlyCdEmpresa);
    // eslint-disable-next-line
  }, [values.linhas]);

  return { companies: filteredCompanies, lines, loading };
};

function filterCompaniesByLines(lineList, companyList) {
  let filtered = [];
  lineList.forEach(line => {
    const companyLines = companyList.filter(company => +company.cdEmpresa === +line.cdEmpresa);
    filtered = [...filtered, ...companyLines];
  });
  return _.uniqBy(filtered, 'cdEmpresa');
}

function getCompanyObjectsFromIds(idList, companyList) {
  let filtered = [];
  idList.forEach(companyId => {
    const foundLine = companyList.find(company => +company.cdEmpresa === +companyId);
    if (foundLine) filtered.push(foundLine);
  });
  return filtered;
}

function getLineObjectsFromIds(idList, lineList) {
  let filtered = [];
  idList.forEach(lineId => {
    const foundLine = lineList.find(line => +line.cdLinha === +lineId);
    if (foundLine) filtered.push(foundLine);
  });
  return filtered;
}
